"use client";
import Link from "next/link";
import Container from "../components/container/Container";
import React from "react";

const NavBar = () => {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    const hrefAttr = e.currentTarget.getAttribute("href") || "";
    const hashIndex = hrefAttr.indexOf("#");

    if (hashIndex === -1) {
      window.location.href = hrefAttr;
      return;
    }

    const path = hrefAttr.slice(0, hashIndex) || "/";
    const targetId = hrefAttr.slice(hashIndex + 1);
    const isHome =
      window.location.pathname === "/" || window.location.pathname === "";

    // Depuis une autre page : naviguer vers l'accueil avec le hash
    if (path === "/" && !isHome) {
      window.location.href = `/#${targetId}`;
      return;
    }

    const element = document.getElementById(targetId);
    if (element) {
      const offsetTop =
        element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <nav className="nowrap text-nowrap fixed bottom-10 left-0 right-0 z-50 my-0 mx-auto flex items-center justify-center gap-1 px-1 py-1 text-[#e4ded7] sm:w-[440px] md:p-2 lg:w-[440px]">
      <Container
        width="165%"
        height="50px"
        color="rgba(255, 255, 255, 0.1)"
        borderRadius={10}
        top="0px"
        left="0px"
        angle={0}
      >
        <nav className="nowrap bottom-30 fixed left-0 right-0 z-50 my-0 mx-auto flex items-center justify-center gap-1 rounded-lg px-1 py-1 text-[#e4ded7] sm:w-[440px] md:p-2 lg:w-[440px]">
          <Link
            href="/"
            data-blobity-magnetic="false"
            aria-label="Scroll to Home Section"
          >
            <h4 className="py-2 px-2 text-[12px] sm:px-4 sm:text-[14px] md:py-1 md:px-4">
              ACCUEIL
            </h4>
          </Link>

          <Link
            href="/#formations"
            data-blobity-magnetic="false"
            aria-label="Scroll to Formations Section"
            onClick={handleScroll}
          >
            <h4 className="py-2 px-2 text-[12px] sm:px-4 sm:text-[14px] md:py-1 md:px-4">
              FORMATIONS
            </h4>
          </Link>

          <Link
            href="/experiences"
            data-blobity-magnetic="false"
            aria-label="Scroll to Experience Section"
          >
            <h4 className="py-2 px-2 text-[12px] sm:px-4 sm:text-[14px] md:py-1 md:px-4">
              EXPÉRIENCES
            </h4>
          </Link>

          <Link
            href="/work"
            data-blobity-magnetic="false"
            aria-label="Scroll to Work Section"
          >
            <h4 className="py-2 px-2 text-[12px] sm:px-4 sm:text-[14px] md:py-1 md:px-4">
              PROJETS
            </h4>
          </Link>

          <Link
            href="/#contact"
            data-blobity-magnetic="false"
            aria-label="Scroll to Contact Section"
            onClick={handleScroll}
          >
            <h4 className="py-2 px-2 text-[12px] sm:px-4 sm:text-[14px] md:py-1 md:px-4">
              CONTACT
            </h4>
          </Link>
        </nav>
      </Container>
    </nav>
  );
};

export default NavBar;
